<script>
import store from "@/state/store";
var state = store._modules.root._children.auth.state;

export default {
  data() {
    return {
      empSalaryItems: [],
      allawanceLevels: [
        {
          name: "الأجر الإبتدائي",
          name_en: "Basic Salary",
          value: 0,
        },
        {
          name: "علاوة 1",
          name_en: "Allawance Level 1",
          value: 1,
        },
        {
          name: "علاوة 2",
          name_en: "Allawance Level 2",
          value: 2,
        },
        {
          name: "علاوة 3",
          name_en: "Allawance Level 3",
          value: 3,
        },
        {
          name: "علاوة 4",
          name_en: "Allawance Level 4",
          value: 4,
        },
        {
          name: "علاوة 5",
          name_en: "Allawance Level 5",
          value: 5,
        },
        {
          name: "علاوة 6",
          name_en: "Allawance Level 6",
          value: 6,
        },
      ],
      emp: {},
      currentPage: 1,
      perPage: 8,
      rows: 0,
      searchEmpFiles: null,
      EmpFilesSearchMode: false,
      searchModel: "",
      state: state,
      openModal: false,
      allsalaries: [],
      salaryForm : [],
      // appprices:[]
    };
  },
  watch: {
    currentPage() {
      this.get()
    },
    searchModel() {
      if (this.searchModel.length > 0) this.get()
      else {
        this.currentPage = 1
        this.get()
      }
    }
  },
  methods: {
    get() {
      this.http
        .post("salary-items/emp/items", {
          emp_id: parseInt(this.$route.params.id),
          query: this.searchModel,
          limit: this.perPage,
          page: this.currentPage
        })
        .then((res) => {
          this.empSalaryItems = res.data;
          // this.emp = res.employee;
          this.rows = res.tot

          console.log('ccoomm', this.empSalaryItems, this.rows)
        });
    },
    UpdateValue(item){
      console.log('ha', item.salary_item.id, item.value, item)
      const obj = {value: item.value}
      this.http.put('salary-items/emps/update-salaryitem', item.id, obj).then(() =>{
        this.get()
      })
    },
    getAllSalaries() {
      this.http.get('salary-items/all-salaries').then((res) => {
        this.allsalaries = res.data
      })
    },
    AddSalaryRow() {
      this.salaryForm.push({selectedSalaryItem: null, value: ''})
    },
    AddSalaryItem() {
      console.log('items', this.salaryForm)
      this.http.post('salary-items/emps/add-salary', {obj: this.salaryForm, emp_id: this.$route.params.id}).then(() => {
        this.get()
        this.openModal = false
        this.salaryForm = []
      })
    },
    DeleteSalary(app){
      console.log('cccc', app)
      this.http.post('salary-items/emps/delete',{salary_id: app.id, emp_id: this.$route.params.id}).then(() => {
        this.currentPage = 1
        this.get()
      })
    },
  },
  computed: {
    salaries() {
      const idsInA = new Set(this.empSalaryItems.map(item => item.id));
      return this.allsalaries.filter(item => !idsInA.has(item.id));
    }
  },
  created() {
    this.get();
    this.getAllSalaries()
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-4">
            <div class="col-6">
              <div class="search-box chat-search-box w-50">
                <div class="position-relative">
                  <input
                    @keyup="search()"
                    type="text"
                    class="form-control fa-lg text-light"
                    :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                    :placeholder="$t('popups.search')"
                    v-model="searchModel"
                    style="background-color: #2a3042 !important"
                  />
                  <i class="bx bx-search-alt search-icon text-light"></i>
                </div>
              </div>
            </div>
            <div class="col-6" style="display: flex; justify-content: flex-end">
              <!-- <button
                class="btn-close text-light"
                v-if="EmpFilesSearchMode"
                @click="cancelappsearchMode()"
              ></button> -->
              <button type="button" @click="openModal=true" class="btn btn-light float-end mb-4">
                <span class="bx bxs-plus-circle float-end fa-2x" style="color: #2a3042 !important" ></span>
              </button>
            </div>
          </div>
          <div class="table-responsive">
            <table
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              class="table table-centered table-nowrap table-striped table-hover align-middle"
            >
              <thead>
                <tr
                  class="text-light"
                  style="background-color: #2a3042 !important"
                >
                  <th scope="col">#</th>
                  <th scope="col">{{ $t("emp_salary_items.name") }}</th>
                  <th scope="col">{{ $t("emp_salary_items.value") }}</th>
                  <!-- <th scope="col">{{ $t("emp_files.operations") }}</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(app, index) in empSalaryItems" :key="app" class="">
                  <td>{{ ((currentPage - 1) * perPage)  + index + 1 }}</td>
                  <td>
                    {{
                      $i18n.locale == "ar" ? app.name : app.name_en
                    }}
                  </td>
                  <td>
                    <div class="d-flex gap-4">
                      <currency-input  v-model="app.value" @change="UpdateValue(app)" />
                      <button class="btn btn-danger" @click="DeleteSalary(app)"><i class="bx bx-trash"></i></button>
                    </div>        
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <BPagination :total-rows="rows" :per-page="perPage" v-model="currentPage"/>
  </div>
  <!-- end  table -->
  <!-- Button trigger modal -->
   <BModal hide-footer v-model="openModal" hide-header-close :title="$t('emp_salary_items.addsalary')">
      <BForm @submit.prevent="AddSalaryItem">
        <div class="d-flex flex-column mb-3">
          <div class="d-flex justify-content-between">
            <label>{{ $t('emp_salary_items.selectsalaryitem') }}</label>
            <i class="bx bx-plus-medical fs-4" style="cursor: pointer;" @click="AddSalaryRow()"></i>
          </div>
          <div class="mt-2">
            <div v-for="(item, indx) in salaryForm" :key="indx" class="mb-3">
              <div class="d-flex gap-2 justify-content-between">
                <select class="form-select" v-model="item.selectedSalaryItem">
                  <option v-for="(itm, ind) in salaries" :key="ind" :value="itm" >
                    {{ $i18n.locale === 'ar' ? itm.name : itm.name_en }}
                  </option>
                </select>
                <div class="d-flex gap-2">
                  <currency-input v-model="item.value"  class="ms-5"/>
                  <i class="bx bx-x text-danger fs-3 align-items-center" style="cursor: pointer;" @click="this.salaryForm.splice(indx, 1)"></i>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="d-flex justify-content-end gap-4">
          <button class="btn btn-danger" type="button" @click="openModal = false">{{ $t('emp_salary_items.cancel') }}</button>
          <button :disabled="this.salaryForm.length === 0" type="submit" class="btn btn-primary">{{ $t('emp_salary_items.submit') }}</button>
        </div>
      </BForm>
   </BModal>
  <!--end-->
</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>
